import { action, makeObservable, observable, runInAction } from 'mobx';
import { UserApiService } from 'user';
import { User } from 'user/types';
import { RootStore } from './root-store';

export class UserStore {
   user: User | null = null;
   isInit: boolean = true;

   constructor(private readonly rootStore: RootStore) {
      makeObservable(this, {
         user: observable,
         isInit: observable,
         setUser: action,
         setInit: action,
      });
   }

   setUser(user: User): void {
      this.user = user;
   }

   setInit(init: boolean): void {
      this.isInit = init;
   }

   async chekUser(): Promise<void> {
      this.rootStore.globalLoader.show();
      try {
         const res = await UserApiService.loginToken();
         if (res.status === 200) {
            this.setUser(res.response.user);
         }
      } catch (e) {
         console.warn(e);
      } finally {
         this.rootStore.globalLoader.hide();
         if (this.isInit) {
            runInAction(() => {
               this.isInit = false;
            });
         }
      }
   }
}
